import type { CSSProperties, ReactNode } from "react";
import { cn } from "@/lib/utils";

// The signature ravoq frame: 1px gold line, paper mat, arched top whose
// radius is half the width. Children render inside `.tk-legacy`, which
// restores the pre-redesign inherited type so templates look unchanged.
// Give it a definite `width` inside shrink-to-fit parents (flex items
// without a basis) — the frame is a size container and collapses otherwise.
export function ArchFrame({
  children,
  width,
  size = "md",
  hover = false,
  aspect,
  className,
  innerStyle,
}: {
  children: ReactNode;
  width?: number | string;
  size?: "md" | "sm";
  hover?: boolean;
  aspect?: string;
  className?: string;
  innerStyle?: CSSProperties;
}) {
  return (
    <div
      className={cn("tk-arch", size === "sm" && "tk-arch--sm", hover && "tk-arch--hover", className)}
      style={width != null ? { width } : undefined}
    >
      <div className="tk-arch__frame">
        <div
          className="tk-arch__inner tk-legacy"
          style={aspect || innerStyle ? { ...(aspect ? { aspectRatio: aspect } : null), ...innerStyle } : undefined}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
